// Archive.js
import React, { useEffect, useState } from "react";
import { FiEdit, FiTrash2, FiArchive } from "react-icons/fi";
import SharedLayout from "./SharedLayout";
import "./App.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import ConfirmModal from "./modals/ConfirmModals";
import InfoModal from "./modals/InfoModals";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Archive = () => {
  const { userId } = useParams();

  const [courses, setCourses] = useState([]);
  const [editCourse, setEditCourse] = useState(null); // “iki seçenekli” modal
  const [deleteCourse, setDeleteCourse] = useState(null); // silme onayı
  const [info, setInfo] = useState({
    open: false,
    type: "info",
    title: "",
    message: "",
  });

  // Dashboard endpoint’ini kullanıp ARCHIVED filtreliyoruz (daha stabil)
  useEffect(() => {
    const fetchArchived = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/courses/${userId}`);
        const archived = (res.data?.courses || [])
          .filter((c) => c.status === "ARCHIVED")
          .map((c) => ({
            id: c.id,
            title: c.name,
            status: c.status,
          }));
        setCourses(archived);
      } catch (err) {
        console.error("Archived fetch error:", err);
        setInfo({
          open: true,
          type: "error",
          title: "Liste alınamadı",
          message: "Arşivli eğitimler getirilirken bir hata oluştu.",
        });
      }
    };
    if (userId) fetchArchived();
  }, [userId]);

  const closeInfo = () => setInfo((p) => ({ ...p, open: false }));

  // “Eğitimi tekrar yayınla” -> DRAFT’a al
  const putBackToDraft = async (course) => {
    try {
      await axios.post(
        `${BACKEND_URL}/courses/${course.id}/unarchive`,
        { status: "DRAFT" }
      );
      // listeden düş
      setCourses((prev) => prev.filter((c) => c.id !== course.id));
      setEditCourse(null);
      setInfo({
        open: true,
        type: "success",
        title: "Güncellendi",
        message: `"${course.title}" taslağa alındı.`,
      });
    } catch (err) {
      console.error("Patch to DRAFT error:", err);
      setInfo({
        open: true,
        type: "error",
        title: "Güncelleme hatası",
        message: "Eğitim taslağa alınırken sorun oluştu.",
      });
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/courses/${id}`);
      setCourses((prev) => prev.filter((c) => c.id !== id));
      setDeleteCourse(null);
      setInfo({
        open: true,
        type: "success",
        title: "Silindi",
        message: "Eğitim kalıcı olarak silindi.",
      });
    } catch (err) {
      console.error("Delete error:", err);
      setInfo({
        open: true,
        type: "error",
        title: "Silme hatası",
        message: "Eğitim silinirken bir hata oluştu.",
      });
    }
  };

  return (
    <SharedLayout pageTitle="ARŞİV İÇERİKLER">
      {/* Courses Section */}
      <div className="mb-8">
        <h2 className="text-xl font-bold text-gray-800 mb-4">İÇERİKLER</h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8">
          {courses.length === 0 ? (
            <div className="col-span-full text-center py-12">
              <p className="text-lg font-semibold text-gray-600">
                📂 Arşivlenen eğitim bulunmamaktadır
              </p>
              <p className="text-sm text-gray-400 mt-2">
                Daha önce arşivlediğiniz eğitimler burada listelenecektir.
              </p>
            </div>
          ) : (
            courses.map((course) => (
              <div
                key={course.id}
                className="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                {/* Actions */}
                <div className="flex justify-end gap-2 mb-3">
                  <button
                    className="text-gray-500 hover:text-blue-600 p-1"
                    title="Düzenle"
                    onClick={() => setEditCourse(course)}
                  >
                    <FiEdit size={14} />
                  </button>
                  <button
                    className="text-gray-500 hover:text-red-600 p-1"
                    title="Sil"
                    onClick={() => setDeleteCourse(course)}
                  >
                    <FiTrash2 size={14} />
                  </button>
                </div>

                {/* Amber rozet */}
                <div className="inline-flex items-center px-2 py-1 rounded-md mb-2 bg-amber-100 text-amber-800 ring-1 ring-amber-200">
                  <FiArchive className="mr-1" size={12} />
                  <span className="text-xs font-medium">ARŞİVLENDİ</span>
                </div>

                <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-1 break-words">
                  {course.title}
                </h3>
              </div>
            ))
          )}
        </div>
      </div>

      {/* EDIT: iki seçenekli modal (taslak / arşivde kalsın) */}
      {editCourse && (
        <ConfirmModal
          open
          title="Eğitim İşlemi"
          description={`"${editCourse.title}" için bir işlem seçin.`}
          confirmText="Tekrar yayınla"
          cancelText="Arşivle"
          // butonları “oval & büyük” ve yan yana yapalım:
          buttonsClassName="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-between"
          confirmBtnClass="w-full sm:w-1/2 bg-green-600 hover:bg-green-700 text-white"
          cancelBtnClass="w-full sm:w-1/2 border-2 border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
          onConfirm={() => putBackToDraft(editCourse)}
          onCancel={() => setEditCourse(null)}
        />
      )}

      {/* DELETE confirm */}
      {deleteCourse && (
        <ConfirmModal
          open
          title="Eğitimi sil"
          description={`"${deleteCourse.title}" kalıcı olarak silinsin mi?`}
          confirmText="Evet, sil"
          cancelText="Vazgeç"
          buttonsClassName="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-end"
          confirmBtnClass="bg-red-600 hover:bg-red-700 text-white"
          cancelBtnClass="border border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
          onConfirm={() => handleDelete(deleteCourse.id)}
          onCancel={() => setDeleteCourse(null)}
        />
      )}

      {/* Bilgi modali */}
      <InfoModal
        open={info.open}
        type={info.type}
        title={info.title}
        message={info.message}
        onClose={closeInfo}
      />
    </SharedLayout>
  );
};

export default Archive;
